import { useTranslation } from 'react-i18next'

import { IdwellToIdwellSubMenuCompanyList } from '../IdwellToIdwellSubMenuCompanyList'

import * as styles from './IdwellToIdwellSubMenuAvailableItemsSection.module.css'

function IdwellToIdwellSubMenuAvailableItemsSection({
  className = styles.IdwellToIdwellSubMenuAvailableItemsSection,
  items,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      {items.length === 0 ? (
        <div className={styles.noData}>{t('Select.NoDataKey')}</div>
      ) : null}
      <IdwellToIdwellSubMenuCompanyList {...restProps} items={items} />
    </div>
  )
}

export default IdwellToIdwellSubMenuAvailableItemsSection
